<template>
	<div>
		<v-row>
			<v-col cols="12">
				<v-breadcrumbs :items="breadcrumbs">
					<template #divider>
						<v-icon>mdi-chevron-left</v-icon>
					</template>
				</v-breadcrumbs>
			</v-col>
		</v-row>

		<v-row justify="center" no-gutters>
			<v-tabs v-model="tab" centered>
				<v-tab v-for="section in sections" :key="section.title">
					{{ section.title }}
				</v-tab>
			</v-tabs>

			<v-tabs v-if="tab != 0" v-model="contentType" class="elevation-2" centered="centered">
				<v-tab href="#tab-1" class="text-caption">
					الدورات التدريبية
					<v-icon left small>mdi-teach</v-icon>
				</v-tab>

				<v-tab href="#tab-2" class="text-caption">
					الأخبار العامة
					<v-icon left small>mdi-newspaper</v-icon>
				</v-tab>

				<!-- <v-tab href="#tab-3" class="text-caption">
					النقل ببديل
					<v-icon left small>mdi-account-switch</v-icon>
				</v-tab> -->

				<v-tab href="#tab-4" class="text-caption">
					الفعاليات
					<v-icon left small>mdi-calendar</v-icon>
				</v-tab>

				<v-tab href="#tab-5" class="text-caption">
					الوظائف الطبية
					<v-icon left small>mdi-doctor</v-icon>
				</v-tab>

				<v-tab href="#tab-6" class="text-caption">
					المكتبة الطبية
					<v-icon left small>mdi-library</v-icon>
				</v-tab>
			</v-tabs>
			
			<v-tabs-items v-model="tab" style="width: 100%">
				<v-tab-item v-for="section in sections" :key="section.title">
					<v-container>
						<v-row v-if="section.tab == '1'" justify="start">
							<v-col v-for="medium in media" :key="medium.id" cols="6" sm="4" md="4" lg="3" xl="2">
								<v-card outlined class="mx-auto" width="200" max-width="200" height="250" @click="selecting1(medium)">
									<v-row no-gutters>
										<v-col cols="12">
											<v-img :src="medium.coverPic" height="150">
												<div v-if="medium == selectedGroup1" class="white">
													<v-icon left color="green">mdi-check-circle</v-icon>
													الموضوع الاول
												</div>

												<div v-else class="white">
													<v-icon left color="primary">mdi-checkbox-blank-circle-outline</v-icon>
												</div>
											</v-img>
										</v-col>
									</v-row>
									<v-card-title class="text-subtitle-1 word-break max-3-lines">{{ medium.title }}</v-card-title>
								</v-card>
							</v-col>
						</v-row>

						<v-row v-else-if="section.tab == '2'" justify="start">
							<v-col v-for="medium in media" :key="medium.id" cols="6" sm="4" md="4" lg="3" xl="2">
								<v-card outlined class="mx-auto" width="200" max-width="200" height="250" @click="selecting2(medium)">
									<v-row no-gutters>
										<v-col cols="12">
											<v-img :src="medium.coverPic" height="150">
												<div v-if="selectedGroup2.indexOf(medium) != -1" class="white">
													<v-icon left color="green">mdi-check-circle</v-icon>
													المواضيع 2 حتى 5
												</div>
													
												<div v-else class="white">
													<v-icon left color="gradient">mdi-checkbox-blank-circle-outline</v-icon>
												</div>
											</v-img>
										</v-col>
									</v-row>
									<v-card-title class="text-subtitle-1 word-break max-3-lines">{{ medium.title }}</v-card-title>
								</v-card>
							</v-col>
						</v-row>

						<v-row v-else-if="section.tab == '3'" justify="start">
							<v-col v-for="medium in media" :key="medium.id" cols="6" sm="4" md="4" lg="3" xl="2">
								<v-card outlined class="mx-auto" width="200" max-width="200" height="250" @click="selecting3(medium)">
									<v-row no-gutters>
										<v-col cols="12">
											<v-img :src="medium.coverPic" height="150">
												<div v-if="selectedGroup3.indexOf(medium) != -1" class="white">
													<v-icon left color="green">mdi-check-circle</v-icon>
													المواضيع 6 حتى 11
												</div>
													
												<div v-else class="white">
													<v-icon left color="gradient">mdi-checkbox-blank-circle-outline</v-icon>
												</div>
											</v-img>
										</v-col>
									</v-row>
									<v-card-title class="text-subtitle-1 word-break max-3-lines">{{ medium.title }}</v-card-title>
								</v-card>
							</v-col>
						</v-row>

						<v-row v-if="contentType == 'tab-1' || section.tab == '1'" justify="center">
							<v-pagination v-model="coursesPage" :length="coursesPageCount" class="pt-3"></v-pagination>
						</v-row>
						<v-row v-else-if="contentType == 'tab-2'" justify="center">
							<v-pagination v-model="newsPage" :length="newsPageCount" class="pt-3"></v-pagination>
						</v-row>
						<v-row v-else-if="contentType == 'tab-3'" justify="center">
							<v-pagination v-model="replacementsPage" :length="replacementsPageCount" class="pt-3"></v-pagination>
						</v-row>
						<v-row v-else-if="contentType == 'tab-4'" justify="center">
							<v-pagination v-model="eventsPage" :length="eventsPageCount" class="pt-3"></v-pagination>
						</v-row>
						<v-row v-else-if="contentType == 'tab-5'" justify="center">
							<v-pagination v-model="jobsPage" :length="jobsPageCount" class="pt-3"></v-pagination>
						</v-row>
						<v-row v-else-if="contentType == 'tab-6'" justify="center">
							<v-pagination v-model="libraryPage" :length="libraryPageCount" class="pt-3"></v-pagination>
						</v-row>
					</v-container>
				</v-tab-item>
			</v-tabs-items>
		</v-row>

		<v-row justify="start">
			<v-col cols="12">
				<v-divider class="mx-auto" width="80%"></v-divider>
			</v-col>
			<v-col cols="12" class="text-center">
				المواضيع المختارة
			</v-col>
			<v-col v-if="selectedGroup1" cols="6" sm="4" md="4" lg="3" xl="2">
				<!-- @click="selecting1(selectedGroup1)" -->
				<v-card outlined class="mx-auto" width="200" max-width="200" height="250">
					<v-row no-gutters>
						<v-col cols="12">
							<v-img :src="selectedGroup1.coverPic" height="150">
								<div class="white">
									<v-icon left color="green">mdi-check-circle</v-icon>
									الموضوع الاول
								</div>
							</v-img>
						</v-col>
					</v-row>
					<v-card-title class="text-subtitle-1 word-break max-3-lines">{{ selectedGroup1.title }}</v-card-title>
				</v-card>
			</v-col>
			<v-container v-else>
				<v-alert type="info" class="mx-auto" width="100%">
					للتمكن من معاينة أو نشر, يجب عليك اختيار موضوع من "الموضوع الأول"
				</v-alert>
			</v-container>

			<v-col cols="12" class="pa-0"></v-col>

			<template v-if="selectedGroup2">
				<v-col v-for="item in selectedGroup2" :key="item.courseID" cols="6" sm="4" md="4" lg="3" xl="2">
					<!-- @click="selecting2(item)" -->
					<v-card outlined class="mx-auto" width="200" max-width="200" height="250">
						<v-row no-gutters>
							<v-col cols="12">
								<v-img :src="item.coverPic" height="150">
									<div class="white">
										<v-icon left color="green">mdi-check-circle</v-icon>
										المواضيع 2 حتى 5
									</div>
								</v-img>
							</v-col>
						</v-row>
						<v-card-title class="text-subtitle-1 word-break max-3-lines">{{ item.title }}</v-card-title>
					</v-card>
				</v-col>
				<v-col v-if="selectedGroup2.length != 4" cols="12">
					<v-container>
						<v-alert type="info" class="mx-auto" width="100%">
							للتمكن من معاينة أو نشر, يجب عليك اختيار 4 مواضيع من "الموضوع الثاني - الخامس"
						</v-alert>
					</v-container>
				</v-col>
			</template>

			<template v-if="selectedGroup3">
				<v-col v-for="item in selectedGroup3" :key="item.courseID" cols="6" sm="4" md="4" lg="3" xl="2">
					<!-- @click="selecting2(item)" -->
					<v-card outlined class="mx-auto" width="200" max-width="200" height="250">
						<v-row no-gutters>
							<v-col cols="12">
								<v-img :src="item.coverPic" height="150">
									<div class="white">
										<v-icon left color="green">mdi-check-circle</v-icon>
										المواضيع 6 حتى 11
									</div>
								</v-img>
							</v-col>
						</v-row>
						<v-card-title class="text-subtitle-1 word-break max-3-lines">{{ item.title }}</v-card-title>
					</v-card>
				</v-col>
			</template>
		</v-row>

		<v-row no-gutters>
			<v-col cols="12" class="text-end px-8">
				<v-btn :disabled="!privs.publish || !isValid" color="primary" class="mx-2" :loading="loading" @click="show">معاينة</v-btn>
				<v-btn :disabled="!privs.download || !isValid" color="primary" class="mx-2" :loading="loading" @click="publish">نشر</v-btn>
			</v-col>
		</v-row>

		<v-dialog
			v-model="showPreview"
			transition="dialog-transition"
			width="90%"
			@click:outside="showPreview = false;"
		>
			<v-card class="fill-height">
				<v-card-text class="fill-height pa-0">
					<iframe id="preview" width="100%" height="100%"></iframe>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			privs: {},
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'المنشورات البريدية', disabled: true }
			],
			tab: 0,

			contentType: 'tab-1',
			
			courses: [],
			news: [],
			replacements: [],
			events: [],
			jobs: [],
			library: [],

			coursesPage: 1,
			newsPage: 1,
			replacementsPage: 1,
			eventsPage: 1,
			jobsPage: 1,
			libraryPage: 1,

			coursesPageCount: 1,
			newsPageCount: 1,
			replacementsPageCount: 1,
			eventsPageCount: 1,
			jobsPageCount: 1,
			libraryPageCount: 1,

			selectedGroup1: null,
			selectedGroup2: [],
			selectedGroup3: [],
			sections: [
				{ title: "الموضوع الأول", tab: "1" },
				{ title: "الموضوع الثاني - الخامس", tab: "2" },
				{ title: "الموضوع السادس - الحادي عشر", tab: "3" }
			],
			loading: false,
			showPreview: null
		};
	},
	computed: {
		isValid() {
			return this.selectedGroup1 != null && this.selectedGroup2.length == 4;
		},
		media() {
			if (this.tab == 0) {
				return this.courses;
			} else {
				if(this.contentType == 'tab-2'){
					return this.news;
				} else if (this.contentType == 'tab-3') {
					return this.replacements;
				} else if (this.contentType == 'tab-4') {
					return this.events;
				} else if (this.contentType == 'tab-5') {
					return this.jobs;
				} else if (this.contentType == 'tab-6') {
					return this.library;
				} else {
					return this.courses;
				}
			}
		}
	},
	watch: {
		coursesPage(newVal) {
			this.courses = [];
			this.getCourses(newVal);
		},
		newsPage(newVal) {
			this.news = [];
			this.getNews(newVal);
		},
		replacementsPage(newVal) {
			this.replacements = [];
			this.getReplacements(newVal);
		},
		eventsPage(newVal) {
			this.events = [];
			this.getEvents(newVal);
		},
		jobsPage(newVal) {
			this.jobs = [];
			this.getJobs(newVal);
		},
		libraryPage(newVal) {
			this.library = [];
			this.getLibrary(newVal);
		}
	},
	mounted() {
		this.getCourses(1);
		this.getNews(1);
		this.getReplacements(1);
		this.getEvents(1);
		this.getJobs(1);
		this.getLibrary(1);
		this.getPrivileges();
	},
	methods: {
		getPrivileges() {
			client
				.get("/api/privilege/newslatterIcons")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		// var route = {
		// 	name: "course",
		// 	params: { courseID: course.courseID }
		// };
		// route = this.$router.matcher.match(route).fullPath;
		// course.url = 'document.location.origin + route';
		getCourses(page) {
			client
				.post("/api/courses/all?page=" + page, { itemsPerPage: 12 })
				.then(response => {
					console.log(response);
					this.coursesPageCount = response.data.data.last_page;
					this.courses = Object.values(response.data.data.data).map(
						course => {
							course.isSelected = false
							course.mediaType = "courses";
							return course;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getNews(page) {
			client
				.post("/api/news/all?page=" + page, { itemsPerPage: 12 })
				.then(response => {
					console.log(response);
					this.newsPageCount = response.data.data.last_page;
					this.news = Object.values(response.data.data.data).map(
						record => {
							record.isSelected = false
							record.mediaType = "news";
							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getReplacements(page) {
			client
				.post("/api/replacements/all?page=" + page, { itemsPerPage: 12 })
				.then(response => {
					console.log(response);
					this.replacementsPageCount = response.data.data.last_page;
					this.replacements = Object.values(response.data.data.data).map(
						record => {
							record.isSelected = false
							record.mediaType = "replacements";
							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getEvents(page) {
			client
				.post("/api/events/all?page=" + page, { itemsPerPage: 12 })
				.then(response => {
					console.log(response);
					this.eventsPageCount = response.data.data.last_page;
					this.events = Object.values(response.data.data.data).map(
						record => {
							record.isSelected = false
							record.mediaType = "events";
							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getJobs(page) {
			client
				.post("/api/jobs/all?page=" + page, { itemsPerPage: 12 })
				.then(response => {
					console.log(response);
					this.jobsPageCount = response.data.data.last_page;
					this.jobs = Object.values(response.data.data.data).map(
						record => {
							record.isSelected = false
							record.mediaType = "jobs";
							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getLibrary(page) {
			client
				.post("/api/library/all?page=" + page, { itemsPerPage: 12 })
				.then(response => {
					console.log(response);
					this.libraryPageCount = response.data.data.last_page;
					this.library = Object.values(response.data.data.data).map(
						record => {
							record.isSelected = false
							record.mediaType = "library";
							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		selecting1 (item) {
			if (item == this.selectedGroup1) {
				this.selectedGroup1 = null
			} else {
				this.selectedGroup1 = item;
			}
		},
		selecting2 (item) {
			var index = this.selectedGroup2.indexOf(item);
			if (this.selectedGroup2.length < 4 && index == -1){
				this.selectedGroup2.push(item);
			} 
			if (index != -1) {
				this.selectedGroup2.splice(index, 1);
			}
		},
		selecting3 (item) {
			var index = this.selectedGroup3.indexOf(item);
			if (this.selectedGroup3.length < 6 && index == -1){
				this.selectedGroup3.push(item);
			} 
			if (index != -1) {
				this.selectedGroup3.splice(index, 1);
			}
		},
		show () {
			this.loading = true;
			var subjects = [
				this.selectedGroup1,
				...this.selectedGroup2,
				...this.selectedGroup3
			];

			var data = {
				data: subjects,
				type: subjects.map(subject => subject.mediaType)
			}
			client
				.post("/api/email/view", data)
				.then(response => {
					console.log(response);
					this.loading = false;
					const html = response.data;
					this.showPreview = true;
					setTimeout(() => {
						var iframe = document.getElementById("preview");
						iframe.contentWindow.document.open();
						iframe.contentWindow.document.write(html);
						iframe.contentWindow.document.close();
					}, 150);
				})
				.catch(err => {
					console.log(err);
					this.loading  = false
					var response = err.response;
					this.$store.dispatch("notify", {
						message: response.data.message,
						color: "error"
					});
				});
		},
		publish () {
			this.loading = true;
			var subjects = [
				this.selectedGroup1,
				...this.selectedGroup2,
				...this.selectedGroup3
			];

			var data = {
				data: subjects,
				type: subjects.map(subject => subject.mediaType)
			}
			clientNotifier
				.post("/api/email/sendToAll", data)
				.finally(() => {
					this.loading  = false
				});
		}
	}
};
</script>

<style scoped>
::v-deep .v-dialog.v-dialog--active {
	height: 100%;
	overflow: hidden;
}
</style>